import { handle420 } from 'apis/HandleError';
import { handleGenericError } from 'apis/HandleError';
import { fetchdata } from './FetchData';
import { apiConfig } from 'config';

export function getAvailablePmCounters(from, to) {
  let postBody = {
    sourceType: 'pm',
    searchSpan: {
      from: {
        dateTime: from
      },
      to: {
        dateTime: to
      }
    }
  };

  return fetchdata(apiConfig.pmServiceGetAvailableCounters, {
    method: 'POST',
    body: JSON.stringify(postBody)
  }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        handleGenericError();
    }
    return;
  });
}

export function getAvailableCmCounters(from, to) {
  let postBody = {
    sourceType: 'cm',
    searchSpan: {
      from: {
        dateTime: from
      },
      to: {
        dateTime: to
      }
    }
  };

  return fetchdata(apiConfig.pmServiceGetAvailableCounters, {
    method: 'POST',
    body: JSON.stringify(postBody)
  }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        handleGenericError();
    }
    return;
  });
}
